var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Transfer',{staticStyle:{"width":"100%"},attrs:{"data":_vm.Salers,"target-keys":_vm.CommunitySalers,"filterable":"","operations":['移除','新增'],"titles":['普通销售','公益销售'],"list-style":_vm.listStyle,"filter-method":_vm.filterMethod},on:{"on-change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }